import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PublicNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  React.useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Solutions', path: '/#solutions', isAnchor: true },
    { name: 'Features', path: '/#features', isAnchor: true },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Track Order', path: '/track' },
  ];

  const handleNavClick = (path, isAnchor) => {
    if (isAnchor && isHome) {
      // If we are on home and it's an anchor, just use standard jump
      const id = path.split('#')[1];
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(path);
    }
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <div className="cursor-pointer" onClick={() => navigate('/')}>
            <img src="/images/logoAuth.png" alt="Flywell Logistics" className="h-8 md:h-10" />
          </div>
          
          <div className="hidden md:flex items-center gap-8 font-medium">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => handleNavClick(link.path, link.isAnchor)}
                className={`${
                  location.pathname === link.path 
                    ? 'text-indigo-600 font-bold' 
                    : 'text-slate-600'
                } hover:text-indigo-600 transition-colors`}
              >
                {link.name}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/login')}
              className="hidden sm:block text-slate-700 hover:text-indigo-600 font-semibold transition-colors"
            >
              Log In
            </button>
            <button
              onClick={() => navigate('/signup')}
              className="px-6 py-2.5 bg-slate-900 text-white rounded-lg hover:bg-indigo-600 transition-colors font-semibold shadow-md active:scale-95"
            >
              Start Shipping
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicNavbar;
